










































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue, Inject } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  decimal,
  numeric,
} from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import LanguagesButtons from "../../buttons/languages-buttons.vue";
import CloseButton from "@/components/buttons/close-button.vue";
import BSwitch from "../../app/switchs/b-switch.vue";
import UploadingImagesToServer from "@/components/app/images/uploading-images-to-server.vue";
import UloadPicture from "../../app/images/upload-picture.vue";
import StandartModal from "@/components/app/standart-modal.vue";
// import ChangeMarkerWikiMap from "@/components/demo/wiki/change-marker-wiki-map.vue";
import ChangePoligonWikiMap from "@/components/demo/wiki/change-poligon-wiki-map.vue";
import WikiPreviewDemo from "@/components/demo/wiki/wiki-preview-demo.vue";
import MainDemo from "@/components/demo/main-demo.vue";

import { preferred_language } from "@/config/languags.config.json";
import { pics } from "@/config/host.config";

import { IWikiObject as IWiki, IWikiCategory } from "@/@types/wiki/wiki-object";
import { ILocale } from "@/@types/locale";
import { Geometry, Point, Position, GeometryType } from "@/@types/wiki/geojson";

@Component({
  components: {
    StandartModal,
    submit: SubmitResetButtonGroop,
    "upload-picture": UloadPicture,
    UploadingImagesToServer,
    LanguagesButtons,
    CloseButton,
    VueEditor,
    BSwitch,
    MainDemo,
    WikiPreviewDemo,
    "change-map": ChangePoligonWikiMap,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
    alert: { required },
    description: { maxLength: maxLength(3000) },
    lat: { required, decimal },
    lon: { required, decimal },
    radius: { required, numeric },
  },
})
export default class WikiObjectForm extends Vue {
  @Prop({ type: Object, default: null }) dot!: IWiki;
  @Prop({ type: Array, default: () => [] }) cats!: Array<IWikiCategory>;

  @Inject({ from: "bgFolder", default: null }) readonly bgfolder!: string;
  @Inject({ from: "posterFolder", default: null }) readonly folder!: string;
  @Inject({ from: "iconFolder", default: null }) readonly iconFolder!: string;
  @Inject({ from: "galleryFolder", default: null }) readonly gFolder!: string;
  @Inject({ from: "categoryFolder", default: null }) readonly cFolder!: string;

  locale = preferred_language;
  showDemo = true;
  wikiIcons: Array<string> = [];
  geojsontypes: Array<GeometryType> = ["Point", "LineString", "Polygon"];
  show = false;

  minRadius = 100;
  maxRadius = 20000;
  stepRadius = 100;

  name = "";
  description = "";
  alert = "";
  icon = "";
  lat = 0;
  lon = 0;
  radius = 500;
  showWikiObj = true;
  onlyShowPush = false;
  poster = "";
  background = "";
  copyright = "";
  category = "";
  gallery: Array<string> = [];
  audio: Array<string> = [];
  video: Array<string> = [];

  location: Geometry = {
    type: "Point",
    coordinates: [],
    radius: this.radius,
  };

  names: ILocale = {};
  descriptions: ILocale = {};
  alerts: ILocale = {};

  get wiki(): Partial<IWiki> {
    return {
      _id: this.dot ? this.dot._id : "",
      show: this.showWikiObj,
      onlyShowPush: this.onlyShowPush,
      category: this.category,
      location: this.location,
      media: {
        gallery: this.gallery,
        audio: this.audio,
        video: this.video,
      },
      src: {
        icon: this.icon,
        poster: this.poster,
        background: this.background,
        copyright: this.copyright,
      },
      name: this.names,
      alert: this.alerts,
      description: this.descriptions,
    };
  }

  @Watch("lat")
  @Watch("lon")
  updateLocationPoint(): void {
    if (this.location.type != "Point" && this.location.type != "MultiPoint")
      return;
    if (!this.lat || !this.lon) return;
    if (this.location.type == "Point")
      this.location.coordinates = [this.lon, this.lat];
    if (this.location.type == "MultiPoint")
      this.location.coordinates.push([this.lon, this.lat]);
  }

  changePoint(geometry: Geometry): void {
    this.location.coordinates = geometry.coordinates as any;
    this.location.radius = geometry.radius;
  }

  deleteMultiPoint(i: number): void {
    if (this.location.coordinates.length == 2) {
      this.location.coordinates = this.location.coordinates[0] as any;
      this.location.type = "Point";
      return;
    }
    this.location.coordinates.splice(i, 1);
  }

  changeMultiPoint(i: number): void {
    if (this.location.type != "MultiPoint") return;
    this.lat = this.location.coordinates[i][1];
    this.lon = this.location.coordinates[i][0];
    this.location.coordinates.splice(i, 1);
  }

  addPoint(): void {
    if (!this.lat || !this.lon) return;

    if (!this.location.coordinates.length) {
      this.location.coordinates = [this.lon, this.lat];
      this.location.type = "Point";
      this.location.radius = this.radius / 111144;
      this.$nextTick(() => {
        this.lat = 0;
        this.lon = 0;
      });
      return;
    }

    if (this.location.type == "Point") {
      const coords = this.location.coordinates;
      this.location.coordinates = [coords as any];
    }
    this.location.coordinates.push([this.lon, this.lat] as any);
    this.location.type = "MultiPoint";
    this.location.radius = this.radius / 111144;
    this.$nextTick(() => {
      this.lat = 0;
      this.lon = 0;
    });
  }

  updateType(oldtype: string, newtype: string): void {
    if (newtype == "Point") {
      if (oldtype == "MultiPoint" || oldtype == "LineString") {
        this.location.coordinates = this.location.coordinates[0] as any;
        return;
      }
      if (oldtype == "MultiLineString" || oldtype == "Polygon") {
        const coords: Position[][] = this.location.coordinates[0] as any;
        this.location.coordinates = coords[0] as any;
        return;
      }
      if (oldtype == "MultiPolygon") {
        const coords: Position[][][] = this.location.coordinates[0] as any;
        this.location.coordinates = coords[0][0] as any;
        return;
      }
    }
    if (newtype == "MultiPoint" || newtype == "LineString") {
      if (oldtype == "Point") {
        this.location.coordinates = [this.location.coordinates] as any;
        return;
      }
      if (oldtype == "LineString" || oldtype == "MultiPoint") return;

      if (oldtype == "MultiLineString" || oldtype == "Polygon") {
        this.location.coordinates = this.location.coordinates[0] as any;
        return;
      }
      if (oldtype == "MultiPolygon") {
        const coords: Position[][][] = this.location.coordinates[0] as any;
        this.location.coordinates = coords[0] as any;
        return;
      }
    }
    if (newtype == "MultiLineString" || newtype == "Polygon") {
      if (oldtype == "Point") {
        this.location.coordinates = [[this.location.coordinates]] as any;
        return;
      }
      if (oldtype == "LineString" || oldtype == "MultiPoint") {
        this.location.coordinates = [this.location.coordinates] as any;
        return;
      }
      if (oldtype == "MultiLineString" || oldtype == "Polygon") return;

      if (oldtype == "MultiPolygon") {
        this.location.coordinates = this.location.coordinates[0] as any;
        return;
      }
    }
    if (newtype == "MultiPolygon") {
      if (oldtype == "Point") {
        this.location.coordinates = [[[this.location.coordinates]]] as any;
        return;
      }
      if (oldtype == "LineString" || oldtype == "MultiPoint") {
        this.location.coordinates = [[this.location.coordinates]] as any;
        return;
      }
      if (oldtype == "MultiLineString" || oldtype == "Polygon") {
        this.location.coordinates = [this.location.coordinates] as any;
        return;
      }
    }
  }

  @Watch("locale")
  localeCreater(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    else this.description = "";
    if (this.alerts)
      this.alert = this.alerts[this.locale] ? this.alerts[this.locale] : "";
    else this.alert = "";
  }
  @Watch("name")
  entryFilmName(): void {
    this.names[this.locale] = this.name;
  }
  @Watch("description")
  entryFilmDescription(): void {
    this.showDemo = true;
    this.descriptions[this.locale] = this.description;
  }
  @Watch("alert")
  entryFilmAlert(): void {
    this.alerts[this.locale] = this.alert;
  }

  createWikiParams(): void {
    if (!this.dot || !this.dot._id) return;

    this.showWikiObj = this.dot.show;
    this.onlyShowPush = this.dot.onlyShowPush;
    this.icon = this.dot.src.icon ? this.dot.src.icon : "";

    if (Array.isArray(this.dot.category))
      this.category = this.dot.category[0]; //TODO: deleted
    else this.category = this.dot.category;

    if (this.dot.location && !Array.isArray(this.dot.location)) {
      this.location.type = this.dot.location.type;
      this.location.coordinates = this.dot.location.coordinates
        ? this.dot.location.coordinates
        : [];
      if (this.location) this.radius = Math.round(this.location.radius);
    }

    this.gallery = this.dot.media.gallery;
    this.audio = this.dot.media.audio;
    this.video = this.dot.media.video;

    this.poster = this.dot.src.poster;
    this.background = this.dot.src.background;
    this.copyright = this.dot.src.copyright;

    this.names = this.dot.name ? this.dot.name : {};
    this.alerts = this.dot.alert ? this.dot.alert : {};
    this.descriptions = this.dot.description ? this.dot.description : {};

    this.localeCreater();
    this.$nextTick(() => {
      this.show = true;
    });
  }

  @Watch("lat")
  getFloatLat(): void {
    const lat = String(this.lat);
    this.lat = Number(lat.replace(/,/, "."));
  }

  @Watch("lon")
  getFloatLon(): void {
    const lon = String(this.lon);
    this.lon = Number(lon.replace(/,/, "."));
  }

  @Watch("radius")
  getFloatRadius(): void {
    this.radius = Number(this.radius);
    this.location.radius = this.radius;
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");
      this.$v.$touch();
      return;
    }
    this.location.radius = this.radius / 111144;
    if (!this.location.coordinates.length && this.lat && this.lon) {
      this.location.type = "Point";
      this.location.coordinates = [this.lon, this.lat];
    }

    this.$emit("change", this.wiki, this.dot ? this.dot._id : "");
  }

  onReset(): void {
    this.name = "";
    this.alert = "";
    this.description = "";
    this.icon = "";
    this.showWikiObj = false;
    this.onlyShowPush = false;
    this.poster = "";
    this.background = "";
    this.copyright = "";
    this.gallery = [];
    this.audio = [];
    this.video = [];
    this.names = {};
    this.descriptions = {};
    this.alerts = {};
    this.lat = 0;
    this.lon = 0;
    this.radius = 0;
    const location: Point = {
      type: "Point",
      coordinates: [],
      radius: 0,
    };
    this.location = location;
  }

  async getWikiIcons(): Promise<void> {
    const params = { path: this.iconFolder };
    try {
      const wikiLables = await this.$axios.get(pics.download, { params });
      if (wikiLables.status === 200) {
        this.wikiIcons =
          wikiLables.data == "Папка не найдена" ||
          wikiLables.data == "Папка пуста"
            ? []
            : wikiLables.data;
      }
    } catch (error) {
      console.error(error);
    }
  }

  mounted(): void {
    this.createWikiParams();
    this.getWikiIcons().then(() => {
      this.show = true;
    });
  }
}
